import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { getAllUsers, mergeOrganisation } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Select } from '@baseV2'

import { InputsWrapper } from '../styles'

const initialState = () => ({
	fromOrg: { value: '', id: 'from-organisation', label: strings(['from', 'organisation']), placeholder: strings(['select', 'from', 'organisation']) },
	toOrg: { value: '', id: 'to-organisation', label: strings(['to', 'organisation']), placeholder: strings(['select', 'to', 'organisation']) },
})

const MergeOrganisation = ({ update }) => {
	const dispatch = useDispatch()
	const [formState, setFormState] = useState(initialState())
	const [orgData, setOrgData] = useState([])

	useEffect(() => {
		getAllUsers()
			.then((response) => setOrgData(response ?? []))
			.catch((err) => console.log(err))
	}, [])

	const orgOptions = useMemo(
		() =>
			(orgData ?? []).map((item) => ({
				...item,
				display_name: item.organisation_name
					? `${item.organisation_name} (${item.organisation_id})`
					: `(${item.organisation_id})`,
			})),
		[orgData]
	)

	const onChange = (key) => (value) => setFormState((state) => ({ ...state, [key]: { ...state[key], value } }))

	const disabled =
		formState.fromOrg.value === '' ||
		formState.toOrg.value === '' ||
		formState.fromOrg.value?.organisation_id === formState.toOrg.value?.organisation_id

	const mergeOrganisationHandler = () => {
		dispatch(showLoader(true))
		mergeOrganisation(formState.fromOrg.value.organisation_id, formState.toOrg.value.organisation_id)
			.then(() => dispatch(showToast(true, strings('organisation_merged'), { type: TOAST_TYPE.SUCCESS })))
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, strings('organisation_merged_failure'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
				dispatch(toggleDrawer(false))
				update()
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Select
						id={formState.fromOrg.id}
						label={formState.fromOrg.label}
						placeholder={formState.fromOrg.placeholder}
						data={orgOptions}
						displayKey='display_name'
						primaryKey='organisation_id'
						value={formState.fromOrg.value}
						onChange={onChange('fromOrg')}
					/>
					<Select
						id={formState.toOrg.id}
						label={formState.toOrg.label}
						placeholder={formState.toOrg.placeholder}
						data={orgOptions}
						displayKey='display_name'
						primaryKey='organisation_id'
						value={formState.toOrg.value}
						onChange={onChange('toOrg')}
					/>
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' disabled={disabled} onClick={mergeOrganisationHandler}>
					{strings('merge')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default MergeOrganisation
